
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/[[...filter]]",
      function () {
        return require("private-next-pages/home/[[...filter]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/[[...filter]]"])
      });
    }
  